import { render, staticRenderFns } from "./color-indicator.vue?vue&type=template&id=da0e116e&"
import script from "./color-indicator.vue?vue&type=script&lang=js&"
export * from "./color-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports